'use es6';

export const FREE = 'FREE';
export const STRIPE = 'STRIPE';
export const PAYPAL = 'PAYPAL';